import React from "react";
import { Button } from "../../../../../components";
import appConfig from "../../../../../util/appConfig";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../store";
import { confirmSperrmuell } from "../../../../../store/slices/sperrmuell";
import transformHexToRgba from "../../../../../util/transformHexToRgba";

const Calw = () => {
  const dispatch = useAppDispatch();
  const { sperrmuelItemInfo } = useAppSelector(
    (state) => state.sperrmuell.admin
  );
  const { itemId } = useParams();

  return (
    <div
      style={
        {
          // display: "flex",
          // justifyContent: "space-between",
        }
      }
    >
      <div
        style={{
          // textAlign: "end",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          text="In Arbeit"
          width="200"
          isOutlined
          outlineColor={
            sperrmuelItemInfo?.status === "inWork"
              ? transformHexToRgba(appConfig.secondaryColor, "0.4")
              : appConfig.secondaryColor
          }
          textColor={
            sperrmuelItemInfo?.status === "inWork"
              ? transformHexToRgba(appConfig.secondaryColor, "0.4")
              : appConfig.secondaryColor
          }
          marginRight="20"
          disabled={sperrmuelItemInfo?.status === "inWork"}
          onClick={() => {
            if (itemId) {
              dispatch(
                confirmSperrmuell({
                  id: itemId,
                  status: "inWork",
                })
              );
            }
          }}
        />
      </div>
    </div>
  );
};

export default Calw;
